module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.e68987a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/views/artistry/makeover/font/AmwayIcons.eot?5v2gxx
// module id = HFrU
// module chunks = 0